// extracted by mini-css-extract-plugin
export default {"downTop":"AppDown_downTop__qZARO","icon":"AppDown_icon__HgmwT"};